import React from 'react'

const IconSvg = () => (
  <svg
    width='50'
    height='50'
    viewBox='0 0 50 50'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.25'>
      <path
        d='M24.9987 45.834C27.2904 45.834 29.1654 43.959 29.1654 41.6673H20.832C20.832 43.959 22.6862 45.834 24.9987 45.834ZM37.4987 33.334V22.9173C37.4987 16.5215 34.082 11.1673 28.1237 9.75065V8.33398C28.1237 6.60482 26.7279 5.20898 24.9987 5.20898C23.2695 5.20898 21.8737 6.60482 21.8737 8.33398V9.75065C15.8945 11.1673 12.4987 16.5007 12.4987 22.9173V33.334L8.33203 37.5007V39.584H41.6654V37.5007L37.4987 33.334Z'
        fill='#1B1B1D'
      />
    </g>
  </svg>
)

export default IconSvg
